import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

import { SsoService } from 'src/app/services/sso/sso.service';
import { TarjetasService } from 'src/app/services/ciudadanos/tarjetas/tarjetas.service';

import { TarjetaModel } from 'src/app/services/ciudadanos/models/tarjeta.model';
import { CiudadanoModel } from 'src/app/services/ciudadanos/models/ciudadano.model';

@Component({
  selector: 'app-ciudadanos-tarjetas',
  templateUrl: './ciudadanos-tarjetas.component.html',
  styleUrls: ['./ciudadanos-tarjetas.component.css']
})
export class CiudadanosTarjetasComponent implements OnInit {
  @ViewChild('gridTarjetasAsignadas') gridTarjetasAsignadas: jqxGridComponent;
  @ViewChild('gridTarjetasLibres') gridTarjetasLibres: jqxGridComponent;
  @Input() ciudadano: CiudadanoModel;
  @Input() guardar = false;

  public clearSelection = false;
  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  /*
    Tarjeta seleccionada para mover
    entre un grid y otro
  */
  tarjetaAsignadaSelect: TarjetaModel;
  tarjetaLibreSelect: TarjetaModel;

  /*
    Listados de tarjetas que se van a asociar/desasociar
    al guardar el ciudadano
  */
  tarjetasToAssociate: any[] = [];
  tarjetasToDisassociate: any[] = [];

  constructor(private tarjetaServicio: TarjetasService, private ssoService: SsoService) {
  }

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'ciudadano': {
            this.ciudadano = changes[propName].currentValue;
            break;
          }
          case 'guardar': {
            this.guardar = changes[propName].currentValue;
            if(this.guardar == true){
              this.onGuardar();
            }
            break;
          }
          default: {
            break;
          }
        }
      }
    }
  }

  ngAfterViewInit(): void {
    this.setGridOptions(this.gridTarjetasAsignadas);
    this.setGridOptions(this.gridTarjetasLibres);

    setTimeout(() => {
      this.initGridTarjetasAsignadas();
      this.initGridTarjetasLibres();
      this.getTarjetasLibres();
    }, 100);
  }

  onGuardar(): void {
    this.tarjetaServicio.associateTarjetasToCiudadano(this.tarjetasToAssociate, this.ciudadano.id);
    this.tarjetaServicio.disassociateTarjetasFromCiudadano(this.tarjetasToDisassociate, this.ciudadano.id);
  }

  setGridOptions(grid: jqxGridComponent) {
    grid.attrColumnsheight = 20;
    grid.attrRowsheight = 20;
  }

  async associateTarjetasToCiudadano(){
    this.tarjetasToAssociate.push({"id": this.tarjetaLibreSelect.id, "master": false});
    this.tarjetasToDisassociate.splice(this.tarjetasToDisassociate.indexOf(this.tarjetaLibreSelect.id), 1);

    this.ciudadano.tarjetas.push(this.tarjetaLibreSelect);
    let index = this.tarjetasLibres.indexOf(this.tarjetaLibreSelect);
    this.tarjetasLibres.splice(index, 1);

    this.gridTarjetasLibres.clearselection();
    this.tarjetaLibreSelect = null;

    this.gridTarjetasAsignadas.updatebounddata();
    this.gridTarjetasLibres.updatebounddata();
  }

  async disassociateTarjetasFromCiudadano(){
    this.tarjetasToDisassociate.push({"id": this.tarjetaAsignadaSelect.id});
    this.tarjetasToAssociate.splice(this.tarjetasToAssociate.indexOf(this.tarjetaAsignadaSelect.id), 1);

    this.ciudadano.tarjetas.splice(this.ciudadano.tarjetas.indexOf(this.tarjetaAsignadaSelect), 1);
    this.tarjetasLibres.push(this.tarjetaAsignadaSelect);

    this.gridTarjetasAsignadas.clearselection();
    this.tarjetaAsignadaSelect = null;

    this.gridTarjetasAsignadas.updatebounddata();
    this.gridTarjetasLibres.updatebounddata();
  }

  /* Grid asignadas */
  columnsTarjetasAsignadas;
  public sourceTarjetasAsignadas: any;
  public adapterTarjetasAsignadas;

  initGridTarjetasAsignadas(){
    this.columnsTarjetasAsignadas =  [
      { text: 'Id', columntype: 'textbox', datafield: 'id', width: 80, hidden: true },
      { text: 'NSMovisat', columntype: 'textbox', datafield: 'nsMovisat', editable: false },
      { text: this.translate('Descripcion'), columntype: 'textbox', datafield: 'descripcion', editable: false, },
      { text: this.translate('Master'), columntype: 'checkbox', datafield: 'master' },
    ];

    this.sourceTarjetasAsignadas = {
      datatype: 'json',
      datafields: [
        { name:'id', type: 'number', map: 'id' },
        { name:'nsMovisat', type: 'string', map: 'nsMovisat' },
        { name:'descripcion', type: 'string', map: 'descripcion' },
        { name:'master', type: 'boolean', map: 'master' }
      ]
    };

    this.sourceTarjetasAsignadas.localdata = this.ciudadano.tarjetas;
    this.adapterTarjetasAsignadas = new jqx.dataAdapter(this.sourceTarjetasAsignadas);

    this.ciudadano.tarjetas.forEach(tarjeta => {
      this.tarjetasToAssociate.push({"id": tarjeta.id, "master": tarjeta.master});
    });
  }

  onCellEdit(event: any){
    this.tarjetasToAssociate.find(t => t.id == event.args.row.id).master = event.args.value;
    this.ciudadano.tarjetas.find(t => t.id == event.args.row.id).master = event.args.value;
  }

  onRowSelectAsignada(event: any){
    this.tarjetaAsignadaSelect = this.ciudadano.tarjetas[event.args.rowindex];
  }

  /* Grid Libres */
  public tarjetasLibres: TarjetaModel[] = [];
  public columnsTarjetasLibres;
  public sourceTarjetasLibres: any;
  public adapterTarjetasLibres;

  initGridTarjetasLibres(){
    this.columnsTarjetasLibres =  [
      { text: 'Id', columntype: 'textbox', datafield: 'id', width: 80, hidden: true },
      { text: 'NSMovisat', columntype: 'textbox', datafield: 'nsMovisat' },
      { text: this.translate('Descripcion'), columntype: 'textbox', datafield: 'descripcion' },
    ];

    this.sourceTarjetasLibres = {
      datatype: 'json',
      datafields: [
        { name:'id', type: 'number', map: 'id' },
        { name:'nsMovisat', type: 'string', map: 'nsMovisat' },
        { name:'descripcion', type: 'string', map: 'descripcion' }
      ]
    };

    this.adapterTarjetasLibres = new jqx.dataAdapter(this.sourceTarjetasLibres);
  }

  onRowSelectLibre(event: any){
    this.tarjetaLibreSelect = this.tarjetasLibres[event.args.rowindex];
  }


  async getTarjetasLibres() {
    this.tarjetasLibres = await this.tarjetaServicio.getTarjetasLibres();
    if(!this.tarjetasLibres){
      this.tarjetasLibres = [];
    }
    this.sourceTarjetasLibres.localdata = this.tarjetasLibres;
    this.adapterTarjetasLibres = new jqx.dataAdapter(this.sourceTarjetasLibres);
  }
}
